import React, { useEffect } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import useGetUser from 'v2/hooks/useGetUser';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Cards } from './Cards';
import { useStyles } from './styles';

export const Reports = () => {
  const classes = useStyles();

  const user = useGetUser();
  const [tours] = useObservable(() => eduzzAccountsService.getTours(), []);
  const [loadingTours] = useObservable(() => eduzzAccountsService.getLoadingTours(), []);
  const [saveTour] = useCallbackObservable((tour) => eduzzAccountsService.saveTourAction(tour), []);
  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);

  useEffect(() => {
    const tourName = 'new_sales_reports';

    const userDidntSeeTour = tours !== null && !tours?.includes(tourName);
    const userIsNotSupport = user !== null && !user.is_support;
    const shouldSave = userDidntSeeTour && userIsNotSupport && !loadingTours;

    shouldSave && saveTour(tourName);
  }, [loadingTours, tours, user, saveTour]);

  if (isLoadingAccount || !user) return null;

  return (
    <>
      <h1 className={classes.title}>Relatórios</h1>
      <h2 className={classes.subtitle}>Tenha todas as informações que precisa para seu negócio digital</h2>

      <Cards />
    </>
  );
};
